<template lang="html">
<form id="contact" @submit.prevent="mail($refs.theform)" ref="theform">
  <div class="container">
    <div class="row">

      <div class="column text-center">
        <h2>Contact Us</h2>
        <p>Call or email us if you have any questions.</p>
        <div class="row details">
          <div class="column text-center">
            <p><img src="//dsbn.org/walkerlivingcampus/img/contact-location.png" alt="Location"></p>
            <p>
              2984 Holland Road<br>Fonthill<br>
              <a href="https://goo.gl/maps/nnUiS4QVZnr" target="_blank">Get Directions</a>
            </p>
          </div>
          <div class="column text-center">
            <p><img src="//dsbn.org/walkerlivingcampus/img/contact-phone.png" alt="Phone"></p>
            <p>905-892-5719</p>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="contact-form">
          <input type="hidden" name="_recipient" value="AdventureCampus">
          <input type="hidden" name="_subject" value="Adventure Campus Contact Form">
          <input type="hidden" name="_preface" value="Someone wanted to get in contact with you from dsbn.org/adventurecampus">

          <div hidden id="loading">Loading</div>
          <div class="error" hidden id="error">Error sending message</div>
          <h3 class="success" hidden>Thank you for contacting us!</h3>

          <div class="form">
            <div class="row ">
              <div class="column form-field">
                <input autocomplete="off" id="Name" name="Name" type="text" placeholder="Your Name">
              </div>
              <div class="column form-field">
                <input id="Email" name="Email" type="text" placeholder="Your E-mail">
              </div>
            </div>
            <div class="row">
              <div class="column form-field">
                <textarea autocomplete="off" name="Message" id="Message" placeholder="Your Message"></textarea>
              </div>
            </div>
            <button type="submit" class="button">Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
</template>

<style lang="less" scoped>
@import '../css/variables';

form {
  background-color: #222;
  background-image: url(../assets/map-background.png);
  background-size: cover;
  padding: 6em 0;
  color: white;

  .text-center { text-align: center; }
  .container {
    margin: 0 auto;
    max-width: @max-width-desktop; }
  .row {
    @media(min-width: @mobile) {
      display: flex;
    }
    .column {
      justify-content: space-between;
      flex-grow: 1;
    }
  }

  .details {
    margin-top: 2em;
  }

  .form-field {
    padding: 1em;
    input, textarea {
      width: 100%;
      display: block;
      padding: 0.5em 1em;
      font-size: 0.8rem;
      background-color: transparent;
      border: 1px solid @adventure-primary;
      border-radius: 5px;
      color: #fff;
      &:focus {
        outline: none;
        border-color: lighten(@adventure-primary, 30%);
      }
    }
  }
  .button {
    @media(max-width: @mobile) {
      display: block;
    }
    transition: border 0.5s, transform 0.1s;
    background-color: @adventure-primary;
    color: white;
    border: 1px solid @adventure-primary;
    margin-left: 1em;
    padding: 0.5em 1em 0.65em;
    line-height: 1;
    font-size: 1rem;
    display: inline-block;
    border-radius: 5px;
    cursor: pointer;
    &:active {
      transform: translateY(1px);
      background-color: darken(@adventure-primary, 10%);
    }
    &:focus {
      outline: none;
      border-color: lighten(@adventure-primary, 30%);
    }
  }
}
</style>

<script>
export default {

  methods: {
    mail(form) {
      var elements = form.elements
      var data = []
      for (var i = 0; i < elements.length; i++) {
        var item = elements.item(i)
        data.push(item.name + '=' + item.value)
      }
      data = data.join('&')

      var formDisplay = form.querySelector('.form')
      var success = form.querySelector('.success')
      var error = form.querySelector('.error')
      success.style.display = 'none'
      error.style.display = 'none'

      // eslint-disable-next-line no-unused-vars
      this.send(data, function(response, xhr) {
        if (response.success) {
          success.style.display = 'block'
          if (formDisplay) formDisplay.style.display = 'none'
        } else if (response.success == false) {
          error.style.display = 'block'
          error.innerHTML = response.error
        }
      }, function() {
        error.style.display = 'block'
        error.innerHTML = 'Could not send email'
      })

      return false
    },

    send(data, callback, errorCallback) {
      var xhr = new XMLHttpRequest()
      xhr.open('POST', '//cdn.dsbn.org/contact/mail.aspx', true)

      //Send the proper header information along with the request
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')

      xhr.onreadystatechange = function() { //Call a function when the state changes.
        if (xhr.readyState == XMLHttpRequest.DONE) {
          if (xhr.status == 200) {
            // Request finished. Do processing here.
            var response = JSON.parse(xhr.responseText)
            callback(response, xhr)
          } else {
            errorCallback()
          }
        }
      }
      xhr.send(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ContactForm.vue?1f506000